export enum onboarding {
  lets_get_started = 'onboarding.lets_get_started',
  want_phone_number = 'onboarding.want_phone_number',
  we_got_your_back = 'onboarding.we_got_your_back',
}